// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1DayPropertiesUpdateSchema = z.object({
  day_property: z.object({
    dates: z.array(z.coerce.string()).describe("Array of dates to lock/unlock in YYYY-MM-DD format"),
    user_ids: z.array(z.number().int()).describe("Array of user IDs to apply the day property to"),
    locked: z.boolean().describe("Whether to lock (true) or unlock (false) the specified days"),
  }),
});
